<template>
  <div>
    <div class="agency-top">
      <img src="../../assets/images/bg_02.jpg" class="img" />
      <div class="statistics">
        <div class="s-l">
          团队业绩
          <span>{{ statistics.sum_price }}</span>
        </div>
        <div class="s-r">
          我的个人业绩
          <span>{{ statistics.history_sum_price }}</span>
        </div>
      </div>
    </div>
    <div class="agency-year">
      <span class="left">{{ statistics.year }}年</span>
      <span class="right">合计：{{ statistics.sum_price }}</span>
    </div>
    <van-cell-group v-for="(item, index) in statistics.month" :key="index">
      <van-cell :title="item.name" :value="item.sum_price" />
    </van-cell-group>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Cell, CellGroup } from 'vant';
  export default {
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    name: 'team',
    data() {
      return {
        statistics: [],
      };
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        this.$api.get('agency/performance', {type:2}, r=>{
          this.statistics = r.data
        })
      }
    }
  }
</script>

<style scoped>
  .statistics{
    position: absolute;
    top:25%;
    left: 5%;
    color:#ffffff;
    font-size: 14px;
    width: 90%;
  }
  .statistics .s-l{
    float: left;
  }
  .statistics .s-l span{
    display: block;
    font-size: 20px;
    margin-top:10px;
    color:#F3CA97;
  }
  .statistics .s-r{
    float: right;
  }
  .statistics .s-r span{
    display: block;
    font-size: 20px;
    margin-top:10px;
    color:#F3CA97;
  }
  .agency-year{
    padding:8px 15px;
    font-size: 14px;
    overflow: hidden;
    color:#5D5D5D;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/team.vue